import React, { createContext, useContext, useState, useEffect } from 'react';
import { ethers } from 'ethers';
import { networks } from './networks';

const NetworkContext = createContext();

export const useNetworkContext = () => useContext(NetworkContext);

export const NetworkProvider = ({ children, provider }) => {
  const [selectedNetwork, setSelectedNetwork] = useState(null);
  const [currentProvider, setCurrentProvider] = useState(provider);
  const [signer, setSigner] = useState(null);

  useEffect(() => {
    const initializeSigner = async (prov) => {
      if (prov) {
        const newSigner = prov.getSigner();
        setSigner(newSigner);
      }
    };

    const initializeNetwork = async (prov) => {
      if (prov) {
        const network = await prov.getNetwork();
        const networkDetails = networks[network.chainId];
        console.log("Initialized network:", networkDetails); // Debugging line
        setSelectedNetwork(networkDetails);
      }
    };

    initializeSigner(provider);
    initializeNetwork(provider);

    if (provider) {
      const handleChainChanged = async (chainId) => {
        const newNetwork = networks[parseInt(chainId, 16)];
        console.log("Chain changed to:", newNetwork); // Debugging line
        setSelectedNetwork(newNetwork);

        const newProvider = new ethers.providers.Web3Provider(provider);
        setCurrentProvider(newProvider);
        await initializeSigner(newProvider);
      };

      provider.on('chainChanged', handleChainChanged);

      return () => {
        provider.removeListener('chainChanged', handleChainChanged);
      };
    }
  }, [provider]);

  return (
    <NetworkContext.Provider value={{ selectedNetwork, setSelectedNetwork, currentProvider, signer }}>
      {children}
    </NetworkContext.Provider>
  );
};
